// Test IDs for the owner-only /admin dashboard.
// See constants/testIds/index.js for the recipe to add a new feature file.

export const ADMIN_LOGIN = {
  emailInput: 'admin-login-email-input',
  passwordInput: 'admin-login-password-input',
  submitButton: 'admin-login-submit-button',
  errorMessage: 'admin-login-error-message',
};

export const ADMIN_LAYOUT = {
  sidebar: 'admin-sidebar',
  navOverview: 'admin-nav-overview',
  navClients: 'admin-nav-clients',
  navAddClient: 'admin-nav-add-client',
  navApprovals: 'admin-nav-approvals',
  navAudits: 'admin-nav-audits',
  navSettings: 'admin-nav-settings',
  logoutButton: 'admin-logout-button',
};

export const ADMIN_OVERVIEW = {
  page: 'admin-overview-page',
  statTotalClients: 'admin-stat-total-clients',
  statActiveClients: 'admin-stat-active-clients',
  statMrr: 'admin-stat-mrr',
  statPendingApprovals: 'admin-stat-pending-approvals',
  statTotalAudits: 'admin-stat-total-audits',
  statPaidSubscriptions: 'admin-stat-paid-subscriptions',
};

export const ADMIN_CLIENTS = {
  page: 'admin-clients-page',
  table: 'admin-clients-table',
  row: 'admin-client-row',
  emptyState: 'admin-clients-empty-state',
  addClientButton: 'admin-add-client-button',
  statusSelect: 'admin-client-status-select',
  deleteButton: 'admin-client-delete-button',
};

export const ADMIN_ADD_CLIENT = {
  page: 'admin-add-client-page',
  businessNameInput: 'admin-add-client-business-name-input',
  contactEmailInput: 'admin-add-client-contact-email-input',
  contactPhoneInput: 'admin-add-client-contact-phone-input',
  packageSelect: 'admin-add-client-package-select',
  gbpLocationInput: 'admin-add-client-gbp-location-input',
  notesInput: 'admin-add-client-notes-input',
  submitButton: 'admin-add-client-submit-button',
  cancelButton: 'admin-add-client-cancel-button',
};

export const ADMIN_APPROVALS = {
  page: 'admin-approvals-page',
  emptyState: 'admin-approvals-empty-state',
  approveButton: 'admin-approval-approve-button',
  rejectButton: 'admin-approval-reject-button',
  typeSelect: 'admin-approval-generate-type-select',
  clientSelect: 'admin-approval-generate-client-select',
  contextInput: 'admin-approval-generate-context-input',
  generateButton: 'admin-approval-generate-button',
  publishNote: 'admin-approval-publish-note',
};

export const ADMIN_AUDITS = {
  page: 'admin-audits-page',
  emptyState: 'admin-audits-empty-state',
  table: 'admin-audits-table',
  leadsEmptyState: 'admin-leads-empty-state',
  leadRow: 'admin-lead-row',
  placeIdInput: 'admin-lead-place-id-input',
  gridSizeSelect: 'admin-lead-grid-size-select',
  runScanButton: 'admin-lead-run-scan-button',
  leadStatusBadge: 'admin-lead-status-badge',
};

export const ADMIN_SETTINGS = {
  page: 'admin-settings-page',
  companyNameInput: 'admin-settings-company-name-input',
  notificationEmailInput: 'admin-settings-notification-email-input',
  saveButton: 'admin-settings-save-button',
  stripeStatus: 'admin-settings-stripe-status',
  localFalconStatus: 'admin-settings-local-falcon-status',
  ambanjiRelayStatus: 'admin-settings-ambanji-relay-status',
  testRelayButton: 'admin-settings-test-relay-button',
  relayTestResult: 'admin-settings-relay-test-result',
  pricingToggle: 'admin-settings-pricing-toggle',
};
